import { useCallback, useMemo } from 'react';
import { useHeaderHeight } from "./useHeaderHeight.js";

/**
 * This function will return a function which triggers a scroll to the given element
 * @param targetRef element which should be scrolled to
 * @param offset in px
 */
export function useScrollToElement(targetRef, offset = 0) {
  const headerContextHeight = useHeaderHeight();
  const scrollToElement = useCallback(() => {
    if (!targetRef.current) {
      return;
    }
    const currentScrollTop = window.document.documentElement.scrollTop;
    const targetScrollTop = currentScrollTop + targetRef.current.getBoundingClientRect().top;
    const windowHeight = window.innerHeight;
    if (targetScrollTop >= currentScrollTop && targetScrollTop <= currentScrollTop + windowHeight) {
      return;
    }
    window.document.documentElement.scrollTo({
      top: targetScrollTop - headerContextHeight + offset,
      behavior: 'smooth'
    });
  }, [headerContextHeight, targetRef, offset]);
  return useMemo(() => ({
    scrollToElement
  }), [scrollToElement]);
}